import { HashRouter, Route, Routes, useRoutes } from "react-router-dom";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { setLocalStorageItem, ToastContainerMsg } from "./Utils";
import { Suspense } from "react";
import { PublicRoutes } from "./Routes/PublicRoutes";
import { PrivateRoutes } from "./Routes/PrivateRoutes";
// setLocalStorageItem(
//   "accessToken",
//   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Im5hbWUiOiJtb2hpdCIsInVzZXJJZCI6IjY4MzZiN2UxM2NkM2JkNTc4YTY0MzI0MyIsInJvbGUiOiJ1c2VyIn0sImlhdCI6MTc1MTg4NjAyNn0.44_yOdXuZxw9DmJd8iUDaUolOHVRltm6qmS5Uh2Tlpk"
// );

function App() {
  const userRouting = [...PublicRoutes(), ...PrivateRoutes()];
  const UserRouteConfig = () => useRoutes(userRouting);
  return (
    <>
      <HashRouter basename="/">
        <Suspense fallback={<div className="loader"></div>}>
          <UserRouteConfig />
        </Suspense>
      </HashRouter>
      <ToastContainerMsg />
    </>
    // <Routes>
    //   <Route element={<Public />}>
    //     <Route path="/" element={<Login />} />
    //     <Route path="/register" element={<Registration />} />
    //     <Route path="/verification" element={<Verification />} />
    //   </Route>

    //   <Route element={<Protected />}>
    //     <Route path="/lottery/aviator" element={<Aviator />} />
    //     <Route path="/mini-games/mines" element={<Mines />} />

    //     <Route element={<Layout />}>
    //       <Route path="/home" element={<Home />} />
    //       <Route path="/chart" element={<Chart />} />
    //       <Route path="/match" element={<Match />} />
    //       <Route path="/support" element={<Support />} />
    //       <Route path="/share" element={<Share />} />
    //       <Route path="/profile" element={<Profile />} />
    //       <Route path="/disclaimer" element={<Disclaimer />} />
    //       <Route path="/wallet" element={<Wallet />} />
    //       <Route path="/transaction_history" element={<Transactions />} />
    //       <Route path="/game/live_game" element={<LiveGames />} />
    //     </Route>
    //   </Route>
    // </Routes>
  );
}

export default App;
